<template>
    <div class="banner">
        <div class="banner-main container">
            <p class="title">全球领先的金融数据服务提供商</p>
            <p class="advantage">数据全面 实时高效 接入便捷</p>
            <p class="effect">助力区块链赋能实体经济</p>
            <div @click="application" class="apply cursor">申请接入</div>
            <!-- <div class="Interface container">
                <div v-for="(item, index) in listData" :key="index" class="Interface-module">
                    <p class="Interface-number">{{item.number}}</p>
                    <p class="Interface-name">{{item.name}}</p>
                </div>
            </div> -->
        </div>
        <application-access v-on:listen-is-show="showChild" :is-show="isShow" :type="type"></application-access>
    </div>
</template>

<script>
/**
 * 首页banner
 *
 * @requires Home.vue
 * @author liguojie
 */
import ApplicationAccess from '@/components/ApplicationAccess'
import navApi from '@/http/api/v1/apiNavList'
export default {
  components: {
    ApplicationAccess
  },
  name: 'HomeBanner',
  data () {
    return {
      type: 'apply', // 申请类型
      isShow: false, // 显示接入输入模态框
      listData: [] // 接口详情数据
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.listData = navApi.getApiUsedData()
    },
    application () { // 申请接入
      this.isShow = true
    },
    showChild (data) {
      this.isShow = data
    }
  }
}
</script>

<style lang="scss" scoped>
    .banner{
        width: 100%;
        height: 555px;
        background: url(../assets/images/group.jpg) no-repeat center center;
        background-size: 100% 100%;
        .banner-main{
            height: 555px;
            position: relative;
            .title{
                font-size:26px;
                font-family:PingFangSC-Light;
                font-weight:300;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 0;
                top: 170px;
            }
            .advantage{
                position: absolute;
                right: 0;
                top: 232px;
                font-size:16px;
                font-family:PingFangSC-Light;
                font-weight:300;
                color:rgba(255,255,255,1);
            }
            .effect{
                position: absolute;
                right: 0;
                top: 265px;
                font-size:16px;
                font-family:PingFangSC-Light;
                font-weight:300;
                color:rgba(255,255,255,1);
            }
            .apply{
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 0;
                top: 335px;
                width:170px;
                height:45px;
                line-height: 45px;
                text-align: center;
                background:linear-gradient(90deg,rgba(72,178,254,1) 0%,rgba(70,168,255,1) 100%);
            }
            .apply:hover{
                background: linear-gradient(90deg,rgba(90,195,254,1) 0%,rgba(115,197,255,1) 100%);
            }
            .Interface{
                position: absolute;
                right: 0;
                top: 450px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .Interface-module{
                    width: 249px;
                    height: 75px;
                    box-sizing: border-box;
                }
                .Interface-number{
                    box-sizing: border-box;
                    padding-left: 13px;
                    height: 30px;
                    line-height: 30px;
                    border-left: 2px solid rgba(255,255,255,1);
                    font-size:26px;
                    font-family:PingFangSC-Medium;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                }
                .Interface-name{
                    box-sizing: border-box;
                    padding-left: 15px;
                    height: 45px;
                    line-height: 45px;
                    font-size:14px;
                    font-family:PingFangSC-Light;
                    font-weight:300;
                    color:rgba(255,255,255,1);
                    border-left: 1px solid rgba(255,255,255,0.2);
                }
            }
        }
    }
</style>
